// extracted by mini-css-extract-plugin
export var label = "_dq-5";
export var slideContainer = "_dq-0";
export var slider = "_dq-1";
export var sliderLg = "_dq-4";
export var sliderMd = "_dq-3";
export var sliderSm = "_dq-2";